import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppButton } from '../../../../client/components/atom/app-button/app-button';
import { I18nService } from '../../../../../shared/services/i18n.service';

@Component({
  selector: 'app-create-section',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslatePipe,
    AppButton
  ],
  templateUrl: './create-section.html',
  styleUrl: './create-section.scss'
})
export class CreateSection {
  constructor(public i18nService: I18nService) {}

  get projectLink(): string {
    return this.i18nService.generateUrlWithLang('/project');
  }
}
